import type { AppearanceComponent } from '@setplex/tria-api'
import type { AdjustArrayFunc, AdjustObjFunc } from './index.h'

import { BANNERS_CONTENT, ROWS_CONTENT } from '~/features/appearance/components'
import { adjustBannersBundle } from '~/widgets/DynamicModule/model/banners/lib'
import { adjustRowItem } from '~/widgets/DynamicModule/model/rows/lib'

/*
 * Choose formatter by component type.
 */
export function getFormatFunction(
  contentType: AppearanceComponent['contentType']
): AdjustArrayFunc | AdjustObjFunc {
  if (ROWS_CONTENT[contentType]) return adjustRowItem satisfies AdjustArrayFunc
  if (BANNERS_CONTENT[contentType])
    return adjustBannersBundle satisfies AdjustObjFunc

  throw new Error(`Adjust not found for type: ${contentType}`)
}
